import { IAppState } from '../../common/state';

export function getIsRosbankPilotBannerRotationEnabled(state: IAppState): boolean {
  return state.isRosbankPilotBannerRandomRotationEnabled;
}
